import * as React from "react";
const SvgAdd = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 200 200", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M120.1,20H84.4v62.1H20v35.8h64.4V180h35.8v-62.1H180V82.1h-59.9V20z" }));
export default SvgAdd;
